module.exports = __webpack_public_path__ + "static/media/svg-sprite.64178a32.svg";